import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  organization: 'Organization',
  organizations: 'Organizations',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.organization],
  endpoints: {
    getOrganization: {
      providesTags: () => [{ type: TAG_TYPES.organization }],
    },
  },
})

export const { useGetOrganizationQuery } = api
